import { Component, EventEmitter, Input,  Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent  {

  @Input() arrayPage: Array<{ page: number, title: string, active: boolean, label: string }> = []
  @Output() changeValuesEvent = new EventEmitter<number>();

  constructor() { }


  changePage(page: number): void {
    this.changeValuesEvent.next(page)
  }
}
